<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-button @click.prevent="onShowCreatePopup()" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewWarehouseHandling") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('WarehouseHandling') },
                { title: $t('CreateOn') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  {{ row.title }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.persianCreateOn.split(" ")[0] }}<br />{{
                    row.persianCreateOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 60%">
                  <div class="flex justify-center items-center gap-4 flex-wrap">
                    <vs-button
                      radius
                      color="success"
                      size="medium"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="onShowModifyPopup(row)"
                    ></vs-button>
                    <router-link
                      :to="{
                        path: '/WarehouseHandling/Details/' + row.id,
                        query: {
                          breadcrumbNameManual: {
                            persianTitleParent: row.title,
                            Title: 'WarehouseHandling',
                          },
                        },
                      }"
                    >
                      <vs-button
                        color="success"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="flex gap-1"
                        >{{ $t("DetailsWarehouseHandling") }}</vs-button
                      >
                    </router-link>
                    <vs-button
                      @click="onDownloadReportFile(row.id)"
                      class="bg_purple"
                    >
                      {{ $t("DownloadExcelReportWarehouseHanding") }}
                    </vs-button>
                    <vs-button
                      @click="onDownloadItemCodesOfTheSerialsTakenFile(row.id)"
                      class="bg_purple"
                    >
                      {{ $t("DownloadExcelItemCodesOfTheSerialsTaken") }}
                    </vs-button>
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <create-popup
          :show="isCreatePopup"
          @finish="onfinish"
          @close="closeCreatePopup"
        ></create-popup>
        <modify-popup
          :show="isModifyPopup"
          :warehouseHanding="warehouseHanding"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import ModifyPopup from "./ModifyPopup";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_WarehouseHandling_Index",
  components: {
    DataGrid,
    CreatePopup,
    ModifyPopup,
  },
  data() {
    return {
      stockTakingId: "",
      warehouseHanding: {},
      isCreatePopup: false,
      isModifyPopup: false,
      gridDataSource: {
        type: "app",
        service: "Inventory/api/StockTakingQuery",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      exportReportFile: "excel/exportReportFile",
      exportItemCodesOfTheSerialsTakenFile:
        "excel/exportItemCodesOfTheSerialsTakenFile",
    }),
    closeModifyPopup() {
      this.isModifyPopup = false;
    },
    closeCreatePopup() {
      this.isCreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      this.closeModifyPopup();
      this.$refs.grid.renderGrid(1, true);
    },

    onShowModifyPopup(row) {
      this.isModifyPopup = true;
      this.warehouseHanding = row;
    },

    onShowCreatePopup() {
      this.isCreatePopup = true;
    },
    onDownloadReportFile(stockTakingId) {
      this.exportReportFile(stockTakingId);
    },
    onDownloadItemCodesOfTheSerialsTakenFile(stockTakingId) {
      this.exportItemCodesOfTheSerialsTakenFile(stockTakingId);
    },
  },
};
</script>
